import { render, staticRenderFns } from "./ItemGroupForm.vue?vue&type=template&id=7ac40917"
import script from "./ItemGroupForm.vue?vue&type=script&lang=js"
export * from "./ItemGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports